// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"8881800a","88":"340bed60","195":"66b25b89","283":"5ecfb857","393":"56bf8c26","711":"61f9bc13"}[chunkId] + ".chunk.js";
};